import {
	useId,
	type LabelHTMLAttributes,
	type TextareaHTMLAttributes,
} from 'react'

import { ErrorList } from '#app/components/form/error-list.tsx'
import { type ListOfErrors } from '#app/components/form/types.ts'
import { Label } from '#app/components/ui/label.tsx'
import { Textarea } from '#app/components/ui/textarea.tsx'
import { cn } from '#app/utils/misc.tsx'

export function TextareaField({
	labelProps,
	textareaProps,
	descriptionProps,
	errors,
	className,
}: {
	labelProps: LabelHTMLAttributes<HTMLLabelElement>
	textareaProps: TextareaHTMLAttributes<HTMLTextAreaElement>
	descriptionProps?: LabelHTMLAttributes<HTMLParagraphElement>
	errors?: ListOfErrors
	className?: string
}) {
	const fallbackId = useId()
	const id = textareaProps.id ?? textareaProps.name ?? fallbackId
	const errorId = errors?.length ? `${id}-error` : undefined
	return (
		<div className={cn('space-y-1.5', className)}>
			<Label htmlFor={id} {...labelProps} />
			<Textarea
				id={id}
				aria-invalid={errorId ? true : undefined}
				aria-describedby={errorId}
				{...textareaProps}
			/>
			{descriptionProps && (
				<p
					{...descriptionProps}
					className={cn(
						'text-muted-foreground text-xs',
						descriptionProps.className,
					)}
				/>
			)}
			<div className="min-h-[16px]">
				{errorId ? <ErrorList id={errorId} errors={errors} /> : null}
			</div>
		</div>
	)
}
